/**
 * How a dispatch went, as `DeliveryWebhookStatusEnum` names it on the backend.
 *
 * `dispatched` means the request left and nothing more is known yet;
 * `confirmed` that the endpoint answered 200; `retrying` that it answered
 * anything else and Celery will try again (up to 3 times, a minute apart);
 * `rejected` that the sending itself blew up.
 */
export const DISPATCH_STATES = [
  { value: 'pending', label: 'Pendiente', tone: 'neutral' },
  { value: 'dispatched', label: 'Enviado', tone: 'info' },
  { value: 'retrying', label: 'Reintentando', tone: 'warning' },
  { value: 'confirmed', label: 'Confirmado', tone: 'success' },
  { value: 'rejected', label: 'Rechazado', tone: 'danger' },
  { value: 'received', label: 'Recibido', tone: 'success' },
];

export const DISPATCH_STATE_OPTIONS = [
  { value: 'all', label: 'Todos' },
  ...DISPATCH_STATES.map(({ value, label }) => ({ value, label })),
];

const BY_VALUE = DISPATCH_STATES.reduce((acc, state) => ({ ...acc, [state.value]: state }), {});

export const getDispatchStateLabel = (value) => BY_VALUE[value]?.label || value || '-';

export const getDispatchStateTone = (value) => BY_VALUE[value]?.tone || 'neutral';

/** Whose webhooks the history shows. */
export const SCOPE_OPTIONS = [
  { value: 'all', label: 'Todos' },
  { value: 'admin', label: 'Por operador' },
  { value: 'seller', label: 'Por seller' },
];
